const estilo_coluna_fixo = {
  backgroundColor: 'white',
  position: 'sticky !important',
  zIndex: '1 !important',
}

const styleHeader = {
  whiteSpace: 'nowrap'
};

export const cabecalhos = [
  {
    text: '',
    value: 'data-table-select',
    style: {
      ...estilo_coluna_fixo,
      minWidth: '30px !important',
      maxWidth: '30px !important',
      right: 'auto',
      left: 0,
    }
  },
  {
    text: 'Grupo',
    value: 'sigla_grupo',
    style: {
      ...estilo_coluna_fixo,
      minWidth: '95px !important',
      maxWidth: '95px !important',
      right: 'auto',
      left: '30px',
      borderRight: '2px solid rgba(0,0,0,.1)',
      cursor: 'pointer',
    },
    customColumnDisabled: true
  },
  {
    text: 'ABC F.',
    value: 'classificacao_criticidade',
    ordenacao_combinada: true,
    inverter_ordenacao: true,
    style: {
      whiteSpace: 'nowrap',
      borderRight: '2px solid rgba(0,0,0,.1)',
    },
    customColumnDisabled: true
  },
  {
    text: 'ABC R.',
    value: 'classificacao_rentabilidade',
    ordenacao_combinada: true,
    style: {
      whiteSpace: 'nowrap',
      borderRight: '2px solid rgba(0,0,0,.1)',
    },
    customColumnDisabled: true
  },
  {
    text: 'Descrição Fornecedor',
    value: 'razao_social',
    styleHeader: {
      ...styleHeader,
      cursor: 'pointer',
    },
  },
  {
    text: 'Cód. Interno',
    value: 'idproduto',
    styleHeader: {
      ...styleHeader,
      cursor: 'pointer',
    },
  },
  {
    text: 'Cód. Fornecedor',
    value: 'cod_produto',
    styleHeader: {
      ...styleHeader,
      cursor: 'pointer',
    }
  },
  {
    text: 'Número Original',
    value: 'numero_original',
    style: {
      minWidth: '120px',
      maxWidth: '120px',
      cursor: 'pointer',
    }
  },
  {
    text: 'Descrição Produto',
    value: 'descricao_produto',
    styleHeader: {
      ...styleHeader,
      cursor: 'pointer',
    }
  },
  {
    text: 'UND',
    value: 'unidade_compra',
    styleHeader: {
      ...styleHeader,
      cursor: 'pointer',
    },
  },
  {
    text: 'Dias Gatilho',
    value: 'tempo_gatilho',
    styleHeader: {
      ...styleHeader,
      cursor: 'pointer',
    },
  },
  {
    text: 'Estoque Atual',
    value: 'estoque',
    styleHeader: {
      ...styleHeader,
      cursor: 'pointer',
    },
  },
  {
    text: 'Cobertura Est. Futura',
    value: 'cobertura_est_futura',
    styleHeader,
    sortable: false
  },
  {
    text: 'Projeção vendas',
    value: 'consumo_medio_mensal',
    styleHeader,
    sortable: false
  },
  {
    text: "Preço compra",
    value: "preco_compra",
    sortable: false,
    style: {
      minWidth: '100px',
      maxWidth: '100px',
    }
  },
  {
    text: 'Compra em pallet',
    value: 'compra_em_palete',
    style: {
      minWidth: '165px',
      maxWidth: '165px',
    }
  },
  {
    text: 'Sugestão de compra',
    value: 'sugestao',
    style: {
      ...estilo_coluna_fixo,
      minWidth: '150px !important',
      maxWidth: '150px !important',
      right: 0,
      left: 'auto',
      borderLeft: '2px solid rgba(0,0,0,.1)',
      cursor: 'pointer',
    },
    // customColumnDisabled: true
  }
]

export const colunas_ordenacao = [
  {
    descricao: 'Grupo',
    campo: 'sigla_grupo',
  },
  {
    descricao: 'Peso Compras',
    campo: 'peso_compras',
    inverter_ordenacao: true,
    numerico: true,
  },
  {
    descricao: 'ABC F.',
    campo: 'classificacao_criticidade',
    inverter_ordenacao: true,
  },
  {
    descricao: 'ABC R.',
    campo: 'classificacao_rentabilidade',
  },
  {
    descricao: 'Descrição Fornecedor',
    campo: 'razao_social',
  },
  {
    descricao: 'Cód. Interno',
    campo: 'idproduto',
  },
  {
    descricao: 'Cód. Fornecedor',
    campo: 'cod_produto',
  },
  {
    descricao: 'Número Original',
    campo: 'numero_original',
  },
  {
    descricao: 'Descrição Produto',
    campo: 'descricao_produto',
  },
  {
    descricao: 'UND',
    campo: 'unidade_compra',
  },
  {
    descricao: 'Dias Gatilho',
    campo: 'tempo_gatilho',
    numerico: true,
  },
  {
    descricao: 'Estoque Atual',
    campo: 'estoque',
    numerico: true,
  },
  {
    descricao: 'Projeção vendas',
    campo: 'consumo_medio_mensal',
    numerico: true,
  },
  {
    descricao: 'Sugestão de compra',
    campo: 'sugestao',
    numerico: true,
  },
  {
    descricao: 'Venda Futura',
    campo: 'estoque_pendente',
    numerico: true,
  }
];
